import { createMapAction } from "chalet-shared";

export const actionCreators = {
    startCallFailedToFindRoomId: createMapAction(
        "START_CALL_FAILED_FIND_ROOM",
        (x: { phoneNumber: string }) => x
    ),
};
